import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Promo from '../Promos/components/Promo';
import getPromosState from '../Promos/store/selectors/getPromos';

const trackingProps = {
    componentName: ['Live', 'Player of the Game']
};

const LiveFeedPromos = ({
    inning,
    type,
    pos
}) => {
    const promos = useSelector(getPromosState(type));

    return promos?.filter((promo) => {
        const promoInningState = promo?.inningState?.toLowerCase();
        const promoInning = promo.inning;
        return promo && (inning === promoInning) && (pos === promoInningState);
    }).map((p) => <Promo trackingProps={trackingProps} {...p} key={'promo-' + pos + type + inning}/>);
};

LiveFeedPromos.propTypes = {
    inning: PropTypes.number,
    type: PropTypes.string,
    pos: PropTypes.string
};

export default LiveFeedPromos;
